// janetWindow — open Janet in her OWN window.
// Desktop shell: the preload bridge asks the main process for the dedicated
// Janet BrowserWindow (one per app; focused if it already exists).
// Browser: a named popup on the bare /janet/window route (no app chrome), so a
// second call re-uses the same popup instead of stacking windows.

export const JANET_WINDOW_PATH = '/janet/window'

export function isJanetWindow() {
  try {
    if (window.chatroneDesktop?.isJanetWindow) return true
    return window.location.pathname === JANET_WINDOW_PATH
  } catch { return false }
}

export function openJanetWindow(sessionId) {
  const path = sessionId ? `${JANET_WINDOW_PATH}?topic=${encodeURIComponent(sessionId)}` : JANET_WINDOW_PATH
  try {
    if (window.chatroneDesktop?.openJanetWindow) {
      window.chatroneDesktop.openJanetWindow(path)
      return true
    }
  } catch { /* fall through to the browser popup */ }
  try {
    const w = 560, h = 780
    const left = Math.max(0, (window.screenX || 0) + (window.outerWidth || w) - w - 24)
    const top  = Math.max(0, (window.screenY || 0) + 60)
    const win = window.open(path, 'chatrone-janet', `popup=yes,width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes`)
    if (win) { win.focus(); return true }
  } catch { /* popup blocked */ }
  window.location.assign('/janet/chat' + (sessionId ? `/${encodeURIComponent(sessionId)}` : ''))
  return false
}
